// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__5Xc54","select":"Header_select__3siOg","clinic":"Header_clinic__3Thl4"};